import { message, Modal } from "antd"
import React from "react"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import ActionArea from "../../components/ActionArea"
import Head from "../../components/Head"
import List from "../../components/List"
import Button from "../../components/UI/Button"
import FloatingButton from "../../components/UI/FloatingButton"
import SmartSearch from "../../components/UI/SmartSearch"
import SwitchInput from "../../components/UI/SwitchInput"
import { useLoading } from "../../context/LoadingProvider/useLoading"
import { getDrawerCashiersList, updateDrawerCashiers } from "../../services/cashiers"
import { notificationError } from "../../services/notification"
import { getPermission } from "../../services/permisssion"
import direction from "../../utils/filterDirectionOrder"
import permissionType from "../../utils/permissionType"
import { SaveOutlined } from '@ant-design/icons'
import { drawerManager } from "../DrawerManagement/types"
import { sendSystemLog, useAuth } from "../../context/AuthProvider/useAuth"

let changedCashiers: drawerManager[] = []


function DrawerCashier(props: {accessLevel: string}) {

  const {canEdit} = useAuth()
  const [validSearch, setValidSearch] = useState(false)
  const [search, setSearch] = useState({
    text: '',
    fieldOrder: '',
    directionOrder: '',
  })
  const [smartSearch, setSmartSearch] = useState({
    type: '',
    id: '',
    name: '',
  })
  const [cashiersList, setCashiersList] = useState<drawerManager[]>([])
  const [inititalCashiersList, setInititalCashiersList] = useState<drawerManager[]>([])
  const history = useNavigate()
  const [modalVisible, setModalVisible] = useState(false)
  const [visibleSaveButton, setVisibleSaveButton] = useState(false)
  const loading = useLoading()
  const log = {
    log_type: 'visited',
    log_object: 'drawer_cashier_management'
  }
  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  useEffect(() => {
    sendSystemLog(log);
  }, [])



  const onRefresh = async (order?: string, directionparam?: string) => {
    if(!validSearch) return notificationError("Please select a valid search")
    loading.addLoading()
    let requestParams = {
      status: 'All',
      [`${smartSearch.type}Id`]: smartSearch.id,
      fieldOrder: '',
      directionOrder: ''
    }
    if(order && directionparam) {
      requestParams = {
        ...requestParams,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      }
      setSearch({
        ...search,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      })
    }
    const response = await getDrawerCashiersList(requestParams)
    const {list} = await getDrawerCashiersList(requestParams)
    setInititalCashiersList(list)
    const filledChanges = manageChangedCashiers(undefined, response.list)
    setCashiersList(filledChanges || response.list)
    setVisibleSaveButton(false)
    loading.removeLoading()
  }

  const requestChangeStatus = async () => {
    let response= {
      count: 0,
      page: null,
      perpage: 0,
      list: [{id: '', canViewDrawerReport: ''}],
    }
    let requestParams = {
      status: 'All',
      [`${smartSearch.type}Id`]: smartSearch.id,
      fieldOrder: '',
      directionOrder: ''
    }
    response = await getDrawerCashiersList(requestParams)
    if(!response || response.count === 0) return notificationError('Could not save drawer management')
    const difference: drawerManager[] = []
    inititalCashiersList.forEach((initial) => {
      const index = cashiersList.findIndex((cashier) => cashier.id === initial.id)
      if(index !== -1 && JSON.stringify(initial) !== JSON.stringify(cashiersList[index])) difference.push(cashiersList[index])
    })
    await updateDrawerCashiers(difference)
    onRefresh()
    setModalVisible(false)
  }

  const onChangeOrder = (order: {column: any, field: string, order: string| undefined}) => {
    if(order.column) return onRefresh(order.field, order.order)
    return onRefresh()
  }

  const changeCanViewDrawerReport = (row: any, e: String) => {
    let list: any[] = cashiersList
    let index: number | null = null
    list.map(({id}, i) => {
      if(id === row.id) index = i
    })
    if(index || index === 0) {
      list[index] = {
        ...row,
        canViewDrawerReport: e
      }
      manageChangedCashiers(list[index])
    }
    
    setVisibleSaveButton(true)
    setCashiersList([...list])
  }

  const manageChangedCashiers = (changed?: drawerManager, listToChange?: drawerManager[]): drawerManager[] | void => {
    if(changed) {
      const index = changedCashiers.findIndex(cashier => changed.id === cashier.id)
      if( index === -1 )  changedCashiers.push(changed)
      if(index || index === 0)  changedCashiers[index] = changed
    }
    if(listToChange) {
      return listToChange.map((cashier) => {
        const index = changedCashiers.findIndex(change => change.id === cashier.id)
        if(index !== -1) return changedCashiers[index]
        return cashier
      })
    }
  }



  return (
    <div className="drawer-cashier">
      <FloatingButton
        text="Save"
        onClick={() => setModalVisible(true)}
        disabled={JSON.stringify(inititalCashiersList) === JSON.stringify(cashiersList) ||!canEdit}
        icon={<SaveOutlined style={{color: '#FFF', fontSize: 18}} />}
      />
      <Modal 
        title="Are you sure you want to change the selected drawer cashiers?" 
        open={modalVisible}
        onOk={() => requestChangeStatus()} 
        onCancel={() => setModalVisible(false)} 
      />
      <Head title="Drawer Cashier Management" />
      <ActionArea buttonAction={onRefresh} buttonText={'Search'} disabled={!validSearch}>
        <SmartSearch
          value={search.text}
          onChange={(e: string) => setSearch({...search, text: e})}
          onValidSearch={setValidSearch}
          label='Smart Search'
          status="active"
          searchBy={['distributor', 'charity', 'location']}
          onObjValueChange={(e: any) => setSmartSearch(e)}
          autoFocus
        />
      </ActionArea>
      <List
        rows={cashiersList}
        onChange={(selectedRowKeys, selectedRows, order) => onChangeOrder(order)}
        columns={[
          {
            title: 'Distributor',
            dataIndex: 'distributor',
            key: 'distributor',
            render: (value: string) => value,
            width: 125,
            sorter: true,
          },
          {
            title: 'Charity',
            dataIndex: 'charity',
            key: 'charity',
            render: (value: string) => value,
            width: 125,
            sorter: true,
          },
          {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            render: (value: string) => value,
            width: 125,
            sorter: true,
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (value: string) => value,
            width: 125,
            sorter: true,
          },
          {
            title: 'POS Drawer Management Enable',
            dataIndex: '',
            width: 50,
            key: 'canViewDrawerReport',
            render: (value: any, record: any) => (
              <SwitchInput
                onChange={(e) => changeCanViewDrawerReport(value, e)}
                options={{check: "true", uncheck: "false"}}
                value={value.canViewDrawerReport}
                disabled={!canEdit}
              />
            ),
          },
        ]}
      />
    </div>
  )
}

export default DrawerCashier